export default "__VITE_ASSET__CmxQYAtt__"